import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { FixtureCounterpartyTypes } from '@shared/utils/constants';
import {
	getCounterparties,
	getPorts,
} from '@client/lib/api';
import { getPortOptions } from '@client/utils/getPortAndRangeOptions';
import useFetchedState from '@client/utils/hooks/useFetchedState';

export type ChartererOption = {
	// In some places we need the propertyname ie. filtering 
	chartererName: string | null,
	// In some places we need label ie. <Select> options
	label: string | null,
	value: number | null
};

export const useMiscHandlers = () => {
	const {
		data: ports,
	} = useQuery(
		['ports'],
		getPorts,
		{
			refetchOnWindowFocus: false,
			retry: false,
			refetchOnMount: false,
			refetchOnReconnect: false,
		},
	);
	const portOptions = getPortOptions(ports ?? []);

	const [charterers, _reloadCharterers, _error, _charterersLoading] = useFetchedState(
		() => getCounterparties(FixtureCounterpartyTypes.CHARTEREROWNER),
	);
	const chartererOptions: ChartererOption[] = useMemo(() => {
		if (charterers == null) {
			return [];
		}

		return charterers.map((c) => ({
			chartererName: c.name,
			label: c.name,
			value: c.id,
		}));
	}, [charterers]);

	return {
		ports,
		portOptions,
		charterers,
		chartererOptions,
	};
};
